<template>
  <v-layout class="pa-1">
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>របាយការណ៏បញ្ចូលទិន្នន័យ
      </v-tab>
      <v-tab class="pl-1 ttext" disabled="true">
        <!-- Remove disable="ture" for clicked -->
        <v-icon left>mdi-table</v-icon>របាយការណ៏សង្ខេប
      </v-tab>
      <v-tab-item>
        <v-card class="pa-2">
          <h3 class="center mg-wrap categoryTitle">របាយការណ៏សាលារៀនសាធារណៈ</h3>
          <v-row row wrap>
            <v-col xs12 sm3 md3>
              <v-select
                class="questionTitle pr-2"
                v-if="a_code"
                :items="academics"
                v-model="a_code"
                outline
                label="ឆ្នាំសិក្សា"
                id="a_code"
              >
              </v-select>
            </v-col>
            <v-col xs12 sm3 md3>
              <v-select
                class="questionTitle pr-2"
                label="ឈ្មោះរាជធានី ខេត្ត"
                :items="province"
                item-text="pKh"
                item-value="pid"
                outline
                ref="pro"
              >
              </v-select>
            </v-col>
            <v-col xs12 sm6 md6>
              <v-select
                class="questionTitle pr-2"
                label="ប្រភេទរបាយការណ៏"
                :items="reportNotInDB"
                item-text="text"
                item-value="value"
                outline
                ref="report_type"
                single-line
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col align="center" justify="center">
              <v-btn
                color="info questionTitle"
                @click.native="show_list(0)"
                small
                >សាលាមិនរក្សាទុក</v-btn
              >
            </v-col>
            <v-col align="center" justify="center">
              <v-btn
                color="info questionTitle"
                @click.native="show_list(1)"
                small
                >សាលាត្រូវសំអាតទិន្នន័យ</v-btn
              >
            </v-col>
            <v-col align="center" justify="center">
              <v-btn
                color="info questionTitle"
                @click.native="show_list(2)"
                small
                >សាលាបញ្ចូលរួច</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col xs12 md12>
              <!--{{ province }}-->
              <not-entry :dataTable="noEntryDataTable"></not-entry>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <!-- Block Quick Summary Reports -->
      <v-tab-item>
        <v-row no-gutters>
          <v-card>
            <v-toolbar flat color="primary" dark>
              <v-toolbar-title
                >របាយការណ៏សង្ខេបស្ថិតិជាទំរង់អិចសែល</v-toolbar-title
              >
            </v-toolbar>
            <!-- Academic Year and Province Selection -->
            <v-card flat>
              <v-row row wrap class="px-1">
                <v-col xs12 sm3 md3>
                  <v-select
                    class="questionTitle pr-2"
                    v-if="a_code"
                    :items="academics"
                    v-model="a_code"
                    outline
                    label="ឆ្នាំសិក្សា"
                    id="a_code"
                  >
                  </v-select>
                </v-col>
                <v-col xs12 sm3 md3>
                  <v-select
                    class="questionTitle pr-2"
                    label="ឈ្មោះរាជធានី ខេត្ត"
                    :items="province"
                    item-text="pKh"
                    item-value="pid"
                    outline
                    menuProps="auto"
                    ref="pror"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-card>
            <!-- Reports list category -->
            <v-card flat>
              <v-chip
                class="ma-2"
                color="teal"
                text-color="white"
                small
                v-for="item in qReportConfig[0].lfile"
                :key="item.value"
                @click="downloadfiles(item)"
              >
                <v-icon left>mdi-file-excel</v-icon>
                {{ item.text }}
              </v-chip>
            </v-card>
          </v-card>
        </v-row>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import axios from "axios";
import { saveAs } from "file-saver";
import appConfig from "@/utils/appConfig";
import notInSystem from "@/components/textbook/reportTextbook.vue";
// get the functions from wash for getting report==>will replace in future
import winsModule from "@/store/modules/wins/index";
import {
  reportNotInDB,
  qReportConfig,
  pProvince,
} from "@/utils/ascf/reportConfig.js";
// import assignPermission from '@/components/admin/assignPermission'
// import changePassword from '@/components/admin/changePassword'

export default {
  components: {
    "not-entry": notInSystem,
  },
  data() {
    return {
      academics: this.$store.state.uiControl.academics,
      a_code: this.$store.state.uiControl.academics[0].value,
      reportNotInDB: reportNotInDB,
      qReportConfig: qReportConfig,
      active_tab: 0,
      tab: null,
    };
  },
  watch: {
    $route: "onLoadProvince",
  },
  computed: {
    /* eslint-disable */

    noEntryDataTable: function () {
      if (this.$store.state.textbook.notEntry != null) {
        return this.$store.state.textbook.notEntry;
      }
    },

    province: function () {
      if (this.$store.state.wins.province.Provinces_KH != null) {
        return this.$store.state.wins.province.Provinces_KH.sort(function (
          a,
          b
        ) {
          return a.pcode - b.pcode;
        });
      }
    },

    /* eslint-enable */
  },
  methods: {
    onLoadProvince: function () {
      this.$store.dispatch("wins/getWinsReport", {
        b_type: 1,
        c_code: "",
        acc_code: this.a_code,
      });
    },

    show_list: function (state) {
      // state is 0 not input, 1 invalid, 2 valid
      let proId = "";
      let rt = 0;
      if (
        typeof this.$refs.pro.selectedItems[0] !== "undefined" &&
        typeof this.$refs.report_type.selectedItems[0] !== "undefined"
      ) {
        proId = this.$refs.pro.selectedItems[0].pid; //get province id
        rt = this.$refs.report_type.selectedItems[0].value + state; //get the report type
        this.$store.dispatch("textbook/getReportNoEntry", {
          pId: proId,
          pStateCode: rt,
          pType: 1,
          acc_code: this.a_code,
        });
      }
    },
    downloadfiles(par) {
      //Check for Academic and Province selected
      if (typeof this.$refs.pror.selectedItems[0] !== "undefined") {
        const params = {
          acc_code: this.a_code,
          pro_code: this.$refs.pror.selectedItems[0].pid,
          export_id: par.value,
          export_name: par.outFile,
        };
        //set loading interface
        this.$store.dispatch("uiControl/setUILoadingData", {
          message: "កំពង់គណនាជាមួយម៉ាសុីនមេ.....",
        });
        axios
          .get(appConfig.climateURL + "/summaryreport", {
            responseType: "blob",
            params,
          })
          .then((res) => {
            this.$store.dispatch("uiControl/setUILoadingSuccess", {
              message: "ការគណនាបានបញ្ចប់...",
            });
            saveAs(res.data, `${par.outFile}`);
          })
          .catch((e) => {
            this.$store.dispatch("uiControl/setUILoadingError", {
              errMessage: "បរាជ័យក្នុងការគណនា​ សូមព្យាយាមម្តងទៀត។",
            });
          });
      }
    },
  },
  mounted() {
    this.$refs.pro.lastItem = 25;
  },
  created() {
    if (!this.$store._modules.root._children[`wins`]) {
      // console.log('reg pre')
      this.$store.registerModule("wins", winsModule);
    }
    this.onLoadProvince();
  },
};
</script>

<style scoped>
.questionTitle {
  font-family: "Siemreap";
  font-size: 14px;
}
.starTitle {
  font-family: "Siemreap";
  font-size: 20px;
}
.categoryTitle {
  font-family: "Siemreap";
  font-weight: bold;
  font-size: 20px;
}
.v-list {
  height: 300px;
  overflow-y: auto;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>

